// @ts-strict-ignore
import { createReducer, keyValueSetReducer, keyValueUpdateReducer } from '@r/helpers/redux-helpers'
import { FsCore } from '@t/fs-core'
import {
  setPageOffset,
  setProductTable,
  SetProductTablePayload,
  updateProductTable,
  UpdateProductTablePayload,
  updateProductTableEligibility,
  UpdateProductTableEligibilityPayload,
} from './product-table-actions'

export const productTablesReducer = createReducer<FsCore.ESProductTablesState>(
  {
    [setProductTable]: (state, { id, productTable }: SetProductTablePayload) =>
      keyValueSetReducer(state, id, productTable),
    [setPageOffset]: (state, { id, pageOffset }) => {
      return keyValueUpdateReducer(state, id, {
        pageOffset,
      })
    },
    [updateProductTable]: (state, { id, pageOffset, selectedSort }: UpdateProductTablePayload) => {
      const updatedTable: FsCore.ESProductTableState = {
        ...state[id],
        pageOffset,
        sorts: {
          ...state[id].sorts,
          selectedSort,
        },
      }
      return keyValueSetReducer(state, id, updatedTable)
    },
    [updateProductTableEligibility]: (
      state,
      { id, eligibilityResults }: UpdateProductTableEligibilityPayload,
    ) => {
      const HDD_ERRORS = 'hdd'
      const errors = (eligibilityResults.errors || []).filter((e) => e.errorType === HDD_ERRORS)

      const updatedTable: FsCore.ESProductTableState = {
        ...state[id],
        eligibilityResults,
        ...(errors && errors.length > 0 && { errors }),
      }
      return keyValueSetReducer(state, id, updatedTable)
    },
  },
  {},
)
